import {useEffect, useState} from "react";
import {useNavigate, useLocation} from "react-router-dom";
import Session from "supertokens-auth-react/recipe/session";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({children}: ProtectedRouteProps) {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    async function checkSession() {
      const exists = await Session.doesSessionExist();
      setIsAuthenticated(exists);
      setIsLoading(false);

      if (!exists) {
        navigate("/auth", {state: {from: location}, replace: true});
      }
    }

    checkSession();
  }, [navigate, location]);

  if (isLoading) {
    return (
      <div className="bg-background flex h-screen items-center justify-center">
        <div className="border-primary h-8 w-8 animate-spin rounded-full border-4 border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  return <>{children}</>;
}
